/* Publish by EComposer at 2025-07-30 02:09:43*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2cdhok88rcv"]=  window.__ectimmers["ecom-2cdhok88rcv"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2cdhok88rcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cdhok88rcv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sg6nh2x0eu9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sg6nh2x0eu9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3u5dvue58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3u5dvue58', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cyl810sf76a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyl810sf76a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsehegmt99j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsehegmt99j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-79g6uzy7zbb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79g6uzy7zbb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w3ail6lm13').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3ail6lm13', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s111rgr5re').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s111rgr5re', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vf3msxh7eug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vf3msxh7eug', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pdmdpm9lu0c"]=  window.__ectimmers["ecom-pdmdpm9lu0c"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-pdmdpm9lu0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdmdpm9lu0c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-urmw263zkv9"]=  window.__ectimmers["ecom-urmw263zkv9"] || {};
if(!this.$el||!window.EComModal)return;const e=this.isLive;let i=this.$el.querySelectorAll("[ecom-modal]");i.length&&e&&new window.EComModal(i,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-urmw263zkv9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urmw263zkv9', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}